export enum MenuItemVariant {
  Danger = 'danger',
  Default = 'default',
}
